<script>
import HKLInput from './HKLInput'
import { onKeyPress } from './HKLInputOperatorNumber.service'

/**
 * @type {import('vue').Component}
 */
const HKLInputOperatorNumber = {
  name: 'HKLInputOperatorNumber',
  extends: HKLInput,
  methods: {
    listenerProcess (listener) {
      listener.keypress = (e) => {
        return onKeyPress(e, this.realValue) || e.preventDefault()
      }
      return listener
    },
  },
}

export default HKLInputOperatorNumber
</script>
